import en from './en';
import fr from './fr';
import de from './de';

export default {fr, en, de};
